import { useState } from 'react';
import { ShiftTeam } from '../../../../shared/types/shiftTypes.ts';
import { ModalSubmitDialog } from '../../../components/modalSubmitDialog.tsx';
import { Operator } from '../../../types/sharedTypeImpl.ts';
import { trpc } from '../../../utils/trpc/trpc.ts';


interface Props {
    operator?: Operator;
    operators: Operator[];
    onOperatorAdded: (operator: Operator) => void;
    onClose: () => void;
}

export function OperatorDialog({
    operator,
    operators,
    onOperatorAdded,
    onClose,
}: Props) {

    const [fullName, setFullName] = useState<string>(operator?.fullName ?? '');
    const [initials, setInitials] = useState<string>(operator?.initials ?? '');
    const [shiftTeam, setShiftTeam] = useState<string>(operator?.shiftTeam ?? '');

    const mutateOperator = trpc.operators.set.useMutation();


    function handleKeyDown(e: React.KeyboardEvent) {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    }

    async function handleSubmit() {
        const operatorCopy: Operator = {
            isActive: true,
            ...operator,
            fullName,
            initials,
            shiftTeam: shiftTeam ? shiftTeam as ShiftTeam : null,
        };

        if (!operatorCopy.fullName || !operatorCopy.initials) {
            alert('Please fill all fields');
            return;
        }

        const otherOperators = operators.filter(it => it._id !== operator?._id);
        if (otherOperators.some(it => it.initials.toUpperCase() === operatorCopy.initials.toUpperCase())) {
            alert('Initials must be unique');
            return;
        }
        if (otherOperators.some(it => it.fullName.toUpperCase() === operatorCopy.fullName.toUpperCase())) {
            alert('Name must be unique');
            return;
        }

        try {
            await mutateOperator.mutateAsync(operatorCopy);
        } catch (error) {
            alert('Failed to save operator.');
            return;
        }

        onOperatorAdded(operatorCopy);
        onClose();
    }

    return (
        <ModalSubmitDialog
            frameStyle={{ width: '360px' }}
            isOpen={true}
            isSubmitting={mutateOperator.isPending}
            onCancel={onClose}
            onSubmit={handleSubmit}
        >
            <div>
                <div>
                    <div>Full name</div>
                    <input
                        className='dialog-form__input'
                        type='text'
                        value={fullName}
                        onChange={e => setFullName(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                </div>
                <div className='dialog-form__field--with-margins' >
                    <div>Initials</div>
                    <input
                        className='dialog-form__input'
                        type='text'
                        value={initials}
                        onChange={e => setInitials(e.target.value)}
                        onKeyDown={handleKeyDown}
                        disabled={!!operator}
                    />
                </div>
                <div className='dialog-form__field--with-margins' >
                    <div>Shift</div>
                    <select
                        className='dialog-form__input'
                        value={shiftTeam}
                        onChange={e => setShiftTeam(e.target.value)}
                        onKeyDown={handleKeyDown}
                    >
                        <option value='' />
                        <option value='A'>A</option>
                        <option value='B'>B</option>
                        <option value='D'>D</option>
                    </select>
                </div>
            </div>
        </ModalSubmitDialog>
    );
}
